import { Reveal } from "@/components/Reveal";
import { Check } from "lucide-react";
import { SERVICES } from "@/data";

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
      <Reveal>
        <p className="overline text-kw-red mb-4">For Buyers & Sellers</p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-kw-ink max-w-3xl leading-[1.02]">
          Whichever side of the table you're on, the strategy is built around you.
        </h2>
      </Reveal>

      <div className="mt-16 space-y-20 sm:space-y-28">
        {SERVICES.map((srv, i) => (
          <div
            key={srv.tag}
            className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}
          >
            <Reveal className="lg:[direction:ltr]">
              <div className="relative overflow-hidden">
                <img src={srv.image} alt={srv.title} className="w-full h-[340px] sm:h-[460px] object-cover" />
                <div className="absolute top-0 left-0 bg-kw-red text-white px-5 py-2 overline">{srv.tag}</div>
              </div>
            </Reveal>

            <Reveal delay={0.12} className="lg:[direction:ltr]">
              <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-kw-ink leading-[1.05]">
                {srv.title}
              </h3>
              <p className="mt-5 text-neutral-600 leading-relaxed">{srv.text}</p>
              <ul className="mt-7 space-y-3">
                {srv.points.map((p) => (
                  <li key={p} className="flex items-center gap-3">
                    <span className="w-6 h-6 bg-kw-red text-white flex items-center justify-center shrink-0">
                      <Check size={13} />
                    </span>
                    <span className="text-sm sm:text-base text-neutral-800">{p}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                data-testid={`service-cta-${srv.tag.toLowerCase().replace(/[^a-z]/g, "")}`}
                className="mt-8 inline-flex border border-kw-ink px-7 py-3 text-sm font-semibold tracking-wide hover:bg-kw-ink hover:text-white transition-colors duration-300"
              >
                Let's Talk Strategy
              </a>
            </Reveal>
          </div>
        ))}
      </div>
    </section>
  );
};
